
import React, { Fragment } from 'react';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';

// Constants

import { getOptionsForHardcodedState } from '@constants/ssap/hhmTypes/dropdownOptions';


const EmployeeStateHealthBenefitInfo = props => {

    const {
        healthCoverage: {
            stateHealthBenefit
        },
        idx,
        name,
        state,
        isEmployeeHealthBenefitShown
    } = props;

    if (!isEmployeeHealthBenefitShown) {
        return null;
    }

    const [stateAbbr] = state ? getOptionsForHardcodedState(state) : [{}];
    const personName = normalizeNameOfPerson(name);

    return (
        <Fragment>
            {
                stateHealthBenefit !== null &&

                <div className='grid-col-12' >
                    <div className='grid-row' >
                        <SummaryItem
                            category='ssap.additional_info.summary.state_employer_benefit'
                            replacements={{
                                personName,
                                stateName: stateAbbr.text
                            }}
                            value={stateHealthBenefit}
                            noPriorDataValues = { [ null ] }
                            desc={
                                [
                                    [
                                        `taxHousehold.householdMember[${idx}].healthCoverage.stateHealthBenefit`
                                    ]
                                ]
                            }
                        />
                    </div>
                </div>
            }
        </Fragment>
    );
};

export default EmployeeStateHealthBenefitInfo;